<script setup lang="ts">
import { ROUTE_NAMES } from '~/constants/routes';

// COMPOSABLES
const { tt } = useTypedI18n();
const sellingMethod = useSlpSellingMethod();
const { requireScrapping, requireScrappingOptions } = useSlpParams(sellingMethod);

// DATA
const requireScrappingSelectModel = adaptEmptyOptionModel(requireScrapping);
const requireScrappingSelectOptions = computed(() => prependEmptyOption(requireScrappingOptions.value, tt('slp.filters.scrapping.all')));
</script>
<template>
    <UFormField>
        <USelectMenu v-model="requireScrappingSelectModel" :items="requireScrappingSelectOptions" value-key="value" :search-input="false" />
        <template #help>
            <NuxtLinkLocale :to="{ name: ROUTE_NAMES.FAQ, hash: '#scrapping' }" class="line-clamp-1 break-all underline" target="_blank">
                {{ tt('slp.filters.scrapping.help') }}
            </NuxtLinkLocale>
        </template>
    </UFormField>
</template>
